import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./en.json";
import es from "./es.json";
import zhHans from "./zh-Hans.json";
import vi from "./vi.json";
import ar from "./ar.json";
import ko from "./ko.json";
import ru from "./ru.json";

import ht from "./ht.json";
import ptBR from "./pt-BR.json";
import fr from "./fr.json";

import hi from "./hi.json";
import ne from "./ne.json";


const savedLang = localStorage.getItem("site_lang") || "en";

i18n.use(initReactI18next).init({




  resources: {
  en: { translation: en },
  es: { translation: es },
  "zh-Hans": { translation: zhHans },
  vi: { translation: vi },
  ar: { translation: ar },
  ko: { translation: ko },
  ru: { translation: ru },
  ht: { translation: ht },
  "pt-BR": { translation: ptBR },
  fr: { translation: fr },
  hi: { translation: hi },
  ne: { translation: ne }
},

  lng: savedLang,
  fallbackLng: "en",
  interpolation: { escapeValue: false }
});

export default i18n;


  {/*
  resources: {

    
    en: { translation: en },
    es: { translation: es },
    "zh-Hans": { translation: zhHans },
    "zh-Hant": { translation: zhHant },
    tl: { translation: tl },
    vi: { translation: vi },
    ar: { translation: ar },
    ko: { translation: ko },
    ru: { translation: ru },
    "pt-BR": { translation: ptBR },
    hi: { translation: hi },
    ur: { translation: ur },
    bn: { translation: bn },
    pa: { translation: pa },
    gu: { translation: gu },
    am: { translation: am },
    ti: { translation: ti },
    so: { translation: so },
    ht: { translation: ht },
    ja: { translation: ja },
    de: { translation: de },
    fr: { translation: fr },
    it: { translation: it },
    tr: { translation: tr },
    fa: { translation: fa },
    ps: { translation: ps },
    ne: { translation: ne },
    pl: { translation: pl },
    th: { translation: th },
    sw: { translation: sw }
  },

  */}